export class CreateFileViewModel {
    public dateAdded: Date = new Date();
    public name: string = '';
    public file: File | undefined;
    public fileType: string = '';
    public campaignId: number = -1;
}